import { ref } from "vue";
import { apiGet } from "./api";
import { notifyNetworkError } from "./utils";
import { ProfileTypes } from "@minicity/core";

export enum Environment {
    DEV = "development",
    TEST = "test",
    PROD = "production",
}

export const STATIC_CONFIG = {
    ENV: process.env.NODE_ENV,
    API_ROOT: process.env.VUE_APP_API_ROOT,
    VERSION: process.env.VUE_APP_VERSION,
}

export enum MaintenanceMode { OPEN = "OPEN", CLOSED = "CLOSED" }

export interface Config {
    maintenanceMode: MaintenanceMode;
    maintenanceMessage: string;

    networkMailingAddress: ProfileTypes.Address;
}

export const CONFIG = ref<Config|null>(null);

export const loadConfig = async () => {
    CONFIG.value = await apiGet<Config>("/portal/citizen/config")
    .catch(err => {
        notifyNetworkError("Failed to load portal configuration", err);
        return null;
    });
}